import { exportExcel } from "@api/stores/warehouseCirculation/exportExcel/api";
import { exportPDF } from "@api/stores/warehouseCirculation/exportPDF/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  IWarehouseCirculationGetAllParams,
  IWarehouseCirculationResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IWarehouseCirculationResponse>>,
  IPathBaseParam,
  IPaginationParams & IWarehouseCirculationGetAllParams
>("stores.warehouseCirculations");

export const warehouseCirculations = {
  ...getAllApis,
  exportPDF,
  exportExcel,
};
